import React from 'react';

import H2 from 'components/deprecated/legacyElements/H2';
import IntroStep from './IntroStep';
import styles from './style.module.scss';

export default () => (
  <section className={styles.introductionPane}>
    <H2>
      Enter your space considerations and find out how much space your company
      needs!
    </H2>
    <article className={styles.introductionPaneBody}>
      <H2>How SquareFoot Works</H2>
      <div className={styles.introductionPaneSteps}>
        <IntroStep
          imageDescription="Office space browsing"
          imagePath={require('assets/images/marketing/officeBrowsing.svg')}
          text="Browse office spaces, we get the best matches."
        />
        <IntroStep
          imageDescription="Touring spaces with our brokers"
          imagePath={require('assets/images/marketing/brokerTours.svg')}
          text="Tours for your favorite spaces with our brokers."
        />
        <IntroStep
          imageDescription="Moving in"
          imagePath={require('assets/images/marketing/officeMoving.svg')}
          text="We get the best deal and help you move in."
        />
      </div>
    </article>
  </section>
);
